import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';

export function initSocket(opts) {
  const { Vue, store } = opts;
  const apiEndpoint = process.env.VUE_APP_KOALABOSS_API;
  Vue.use(VueSocketio, io(apiEndpoint), { store });
  const socket = io(apiEndpoint);
  // https://stackoverflow.com/questions/14140414/websocket-was-interrupted-while-page-is-loading-on-firefox-for-socket-io
  // Resolve socket "interrupted" bug
  window.addEventListener('beforeunload', () => {
    if (typeof socket.close === 'function') {
      socket.close();
    }
  });
  return socket;
}
